import { render } from "./studentRestrictedMeals.vue?vue&type=template&id=763b7c24&scoped=true"
import script from "./studentRestrictedMeals.vue?vue&type=script&lang=js"
export * from "./studentRestrictedMeals.vue?vue&type=script&lang=js"

import "./studentRestrictedMeals.vue?vue&type=style&index=0&id=763b7c24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763b7c24"]])

export default __exports__